<template>
  <div class="pl-detail" v-bind:class="{admin: this.$root.authorizedUser}">
    <div class="loading" v-if="loading">
<!--     <div class="loading"> -->
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="PLDetails" class="location-content">

    <div class="print-header">
      <div class="left">
        <img src="../assets/logo.svg">
      </div>
      <div class="right">
        <h3>213.305.0464</h3>
        <h4><A href="mailto:renee@therenees.com">renee@therenees.com</A></h4>
      </div>
      <div class="clear"></div>
    </div>



    <section class="admin-info"  v-bind:class="{mobileshow: mobileShowDetails}" v-if='this.$root.authorizedUser'>
      <section class="admin-inner">
        <div class="column">
          <h2>
            <template v-if="PLDetails.property_buildingname"><small>{{PLDetails.property_buildingname}}</small><br></template>
            {{PLDetails.property_address}}
          </h2>
            <div class="plfield">
              {{PLDetails.property_city}}, {{PLDetails.property_state}} {{PLDetails.property_zip}}
            </div>
          <span class="renees" v-if="PLDetails.renees">Renees</span>

            <div class="plfield">
              <label>Last Used</label>
              <span class="difficultyfield" v-if="PLDetails.last_used">{{PLDetails.last_used}}</span>
              <span class="difficultyfield" v-else>N/A</span>
            </div>

            <div class="plfield">
              <label>Difficulty / Frequency</label>
              <span class="difficultyfield"><i :class='PLDetails.property_difficulty_frequency'></i> {{PLDetails.property_difficulty_frequency}}</span>
            </div>
            <div class="plfield">
              <label>Difficulty / Price</label>
              <span class="difficultyfield"><i :class='PLDetails.property_difficulty_price'></i> {{PLDetails.property_difficulty_price}}</span>
            </div>
            <div class="plfield">
              <label>Difficulty / Usability</label>
              <span class="difficultyfield"><i :class='PLDetails.property_difficulty_usability'></i> {{PLDetails.property_difficulty_usability}}</span>
            </div>

            <a class="filemakerbutton" v-bind:class='{renees: PLDetails.renees}' :href="'fmp://10.0.1.3/PL%20Database%20Interface.fmp12?script=Quick%20Find%20from%20Website&param=%3D%3DPL'+PLDetails.plnumber+'&$PLnumber=%3D%3DPL'+PLDetails.plnumber"><i class="material-icons">folder_open</i> Open in FileMaker</a>
            <a class="editbutton" v-bind:class='{renees: PLDetails.renees}' :href="'https://admin.productionlocations.com/pls/view/'+PLDetails.id"><i class="material-icons">edit</i> Edit</a>

<!--
            <div class="plfield">
              <label>Available For</label>
              Film/TV,  Print
            </div>
-->

<!--
            <div class="plfield">
              <label>Desired Budget</label>
              {{PLDetails.property_budget}}
            </div>

            <div class="plfield">
              <label>Desired Frequency</label>
              {{PLDetails.property_frequency}}
            </div>
-->

<!--
            <div class="subheader">Square Feet</div>

            <div class="plfield">{{PLDetails.property_sqft}} (Lot: {{PLDetails.property_lotsqft}})</div>
-->

<!--
            <div class="subheader">Layout</div>

            <div class="plfield">
                <label>Rooms</label>
                {{PLDetails.property_bedrooms}} Bed / {{PLDetails.property_bath}} Bath<br>
            </div>
            <div class="plfield">
                <label>Garage</label>
                {{PLDetails.property_garage}}
            </div>

            <div class="plfield">
                <label>Levels</label>
                {{PLDetails.property_levels}}
            </div>

            <div class="plfield">
                <label>Facing</label>
                {{PLDetails.property_facing}}
            </div>
-->


        </div>

        <Div class="column">

            <div class="subheader" v-if="PLDetails.property_sqft">Sq Feet</div>
            <div class="plfield" v-if="PLDetails.property_sqft">{{PLDetails.property_sqft}}</div>


            <div class="subheader">Contacts</div>

            <div class="contactswrapper">
              <div class="contactbox" v-for='contact in PLDetails.contacts' v-if="contact.Email !== 'renee@therenees.com'">
                <div class="plfield" v-for="fieldval, fieldname in contact">
                    <label>{{fieldname}}</label>
                    <span>{{fieldval}}</span>
                </div>
              </div>
            </div>

<!--
            <div class="subheader">Considerations</div>

            <div class="plfield">
                <label>Stairs</label>
                {{PLDetails.property_stairs}}
            </div>
            <div class="plfield">
                <label>Kids</label>
                {{PLDetails.property_kids}}
            </div>
            <div class="plfield">
                <label>Pets</label>
                {{PLDetails.property_pets}}
            </div>
-->
        </Div>

        <Div class="column">
<!--
            <div class="subheader">Filming Details</div>
          <div class="plfield">
              <label>Filmed Before?</label>
              {{PLDetails.property_filming}}
          </div>

          <div class="plfield">
              <label>Gated or HOA?</label>
              {{PLDetails.property_gated}}
              <template v-if='PLDetails.property_gated_contact !== ""'><br>{{PLDetails.property_gated_contact}}</template>
          </div>

          <div class="plfield">
              <label>Construction Nearby?</label>
              {{PLDetails.property_construction}}
          </div>

          <div class="plfield">
              <label>Parking</label>
              {{PLDetails.property_parking}}
          </div>

          <div class="plfield">
              <label>Pfd Cleaning Service</label>
              {{PLDetails.property_cleaning}}
              <template v-if='PLDetails.property_cleaning_info !== ""'><br>{{PLDetails.property_cleaning_info}}</template>
          </div>
-->

            <div class="notes-wrapper">
              <div v-if="PLDetails.property_notes">
                <div class="subheader">Additional Notes</div>
                <div class="plfield" v-html="PLDetails.property_notes"></div>
              </div>
              <div v-if="PLDetails.property_hoanotes">
                <div class="subheader">HOA & Management</div>
                <div class="plfield" v-html="PLDetails.property_hoanotes"></div>
              </div>
              <div v-if="PLDetails.property_feenotes">
                <div class="subheader">Rates & Fees</div>
                <div class="plfield" v-html="PLDetails.property_feenotes"></div>
              </div>
              <div v-if="PLDetails.property_usenotes">
                <div class="subheader">Use & Access</div>
                <div class="plfield" v-html="PLDetails.property_usenotes"></div>
              </div>
            </div>

        </Div>
      </section>
    </section>

    <BackToTop></BackToTop>

    <section class="location-body">
      <section class="location-info">
        <section class="info-header">
          <h1>{{ PLDetails.reneenumber }} <strong v-if="PLDetails.reneestatus !== 'publish'" style="color: #9c0000;">{{PLDetails.reneestatus}}</strong></h1>

          <div class="buttons">
            <a v-bind:href="'https://api.therenees.com/pdf/' + PLDetails.plnumber + '/' + PLDetails.reneenumber" target="_blank"><i class="material-icons">insert_drive_file</i> Download .pdf</a>
            <a @click="toggleZipSelect()" v-scroll-to="{el: '.photos', offset: -50}"><i class="material-icons">folder</i> Download .zip</a>
          </div>
          <div class="size-selector">
            <div class="toggle-switch" v-bind:class='{switched: fullsizeview}' @click="toggleFullSizeView()">
              <div class="option" v-bind:class='{highlighted: !fullsizeview}'><i class="material-icons">view_module</i><span> Grid</span></div>
              <div class="option" v-bind:class='{highlighted: fullsizeview}'><i class="material-icons">view_stream</i><span> Full</span></div>
              <div class="highlight"></div>
            </div>
          </div>

        </section>

        <!-- <div class="size-selector">
            <div class="toggle-switch" v-bind:class='{switched: fullsizeview}' @click="toggleFullSizeView()">
              <div class="option" v-bind:class='{highlighted: !fullsizeview}'><i class="material-icons">view_module</i><span> Grid</span></div>
              <div class="option" v-bind:class='{highlighted: fullsizeview}'><i class="material-icons">view_stream</i><span> Full</span></div>
              <div class="highlight"></div>
            </div>
        </div> -->

        <section class="pl-columns" v-bind:class="{mobileshow: mobileShowDetails}">
          <div class="column city">
            <h2 class="printonly">{{ PLDetails.reneenumber }}</h2>
            <h4 v-if="PLDetails.permitarea">Permit Area: <b>LA</b></h4>
            <h4>City: <b>{{PLDetails.property_city}}</b></h4>
            <h4>Zip: <b>{{PLDetails.property_zip}}</b></h4>
          </div>
          <span v-if="!mobileShowDetails" @click='mobileShowDetails = true'>Show Details <i class="material-icons">arrow_drop_down</i></span>
          <div class="column" v-for='category in PLDetails.categories' :class='category.name'>
            <h4>{{category.name}}</h4>
            <p><template v-for='(tag, key, index) in category.tags'>{{tag.name}}<template v-if="index != (Object.keys(category.tags).length - 1)">, </template></template></p>
          </div>
          <div class="column" v-if="PLDetails.building">
            <h4>Building</h4>
            <p><router-link :to='"/browse/building/"+PLDetails.buildingslug'>{{PLDetails.building}}</router-link></p>
          </div>

        </section>
      </section>



      <div class="photos grid" v-if="!fullsizeview">
        <div class="photos-masonry" ref="packery" v-packery='{itemSelector: ".photo", percentPosition: true, columnWidth: ".masonry-sizer"}' transition>
        <div class="masonry-sizer"></div>
        <template v-for='(photo, photoIndex) in filteredPhotos'>
          <div class="photo" v-bind:class='{enlarge: enlargedPhoto == photoIndex}' v-packery-item>
            <div class="photo-inner">
              <div v-if="zipselect" class="zipcheckbox" v-bind:class='{selected: photo.selected}' @click="photo.selected = !photo.selected">
                <i v-if="photo.selected" class="material-icons selected">check_box</i>
                <i v-else class="unselected material-icons">check_box_outline_blank</i>
              </div>
              <template v-else>

                <div v-if="!photosInPullSheet.includes(photo.filename)" class="addtopullsheet" @click="addToPullSheet(photo.filename)">Add</div>
                <div v-else class="addtopullsheet added">Added</div>
              </template>
              <img  :src="'https://img.therenees.com/' + photo.filename" class="grid" @click="photoClick(photoIndex)" />
            </div>
          </div>{{' '}}
        </template>
        </div>
      </div>

      <div class="photos full" v-if="fullsizeview">
        <div class="masonry-sizer"></div>
        <template v-for='(photo, photoIndex) in filteredPhotos'>
          <div class="photo" v-bind:class='{enlarge: enlargedPhoto == photoIndex}'>
            <div class="photo-inner">
  <!--
                <div class="bottom-overlay" @click="addToPullSheet(photo.filename)">
                  <i class="material-icons" v-if="!photosInPullSheet.includes(photo.filename)">add</i><i class="material-icons added" v-else>check</i>
                  <div class="pullsheet-tooltip" v-bind:class="{added: photosInPullSheet.includes(photo.filename)}"><span v-if="!photosInPullSheet.includes(photo.filename)">Add To Pullsheet</span><span v-else class="added">Added To Pullsheet</span></div>
                </div>
  -->
                <div v-if="!photosInPullSheet.includes(photo.filename)" class="addtopullsheet" @click="addToPullSheet(photo.filename)">Add</div>
                <div v-else class="addtopullsheet added">Added</div>

              <img  :src="'https://img.therenees.com/' + photo.filename" class="full" />
            </div>
          </div>{{' '}}
        </template>
      </div>
    </section>

    <transition name="slideup">
      <div v-if="zipselect" class="zipselect-footer">
        <h2>Select photos to include in your download</h2>
        <div class="selectall">Select: <span @click="zipSelectAll(true)">All</span> <span @click="zipSelectAll(false)">None</span></div>
        <p>
          {{selectedPhotoCount}} photo<template v-if="selectedPhotoCount != 1">s</template> selected</p>
        <div class="download">
          <form action="https://api.therenees.com/zip" method="post" @submit="zipDownload()">
            <template v-if="zipDownloading">
              <button disabled="true">Preparing...</button>
            </template>
            <template v-else>
              <div class="button" @click="zipselect = false"><i class="material-icons">cancel</i> Cancel</div>
              <button type="submit"><i class="material-icons">file_download</i> Download</button>
            </template>
            <input type="hidden" name="selectedphotos" v-model="selectedPhotoString"><input type="hidden" name="plnumber" v-model="PLDetails.reneenumber">
          </form>
        </div>
      </div>
    </transition>
    </div><!-- /.content -->
  </div><!-- /.pl-detail -->
</template>

<script>
import BackToTop from './BackToTop'
import {packeryEvents} from 'vue-packery-plugin'

export default {
  name: 'PLDetail',
  data () {
/*
    this.$root.pickLocation(this.$route.params.plno)
    var PLDetails = this.$root.currentLocation
    console.log(PLDetails)
*/
    return {
      loading: false,
      error: null,
      PLDetails: null,
      photofilter: false,
      fullsizeview: false,
      zipselect: false,
      zipDownloading: false,
      activePullSheet: this.$root.activePullSheet,
      mobileShowDetails: false,
      enlargedPhoto: null
    }
  },
  created () {
    document.title = this.$route.params.reneeid + ' - The Renees'
    this.fetchData()
    window.addEventListener('keyup', this.keyListener)
  },
  watch: {
    '$route': 'fetchData',
    'enlargedPhoto': 'renderMasonry',
    'fullsizeview': 'resetMasonry',
    'photofilter': 'resetMasonry'
  },
  methods: {
    fetchData () {
      if (window[this.$route.params.reneeid] !== undefined) {
        var pldata = window[this.$route.params.reneeid]
        pldata.photos.forEach(function (photo) {
          photo.selected = true
        })
        this.PLDetails = pldata
        this.updateMetaDescription()
        return
      }
      this.error = this.PLDetails = null
      this.loading = true
      this.$http.get(this.$root.apiurl + 'pl/' + this.$route.params.reneeid).then(response => {
        this.loading = false
        if (!response.body.success) alert(response.body.message)
        response.body.pl.photos.forEach(function (photo) {
          photo.selected = true
        })
        this.PLDetails = response.body.pl
        this.updateMetaDescription()
      }, response => {
        this.error = response.statusText
      })
    },
    toggleFullSizeView () {
      this.fullsizeview = !this.fullsizeview
      if (this.fullsizeview) this.zipselect = false
    },
    checkPhoto (photo) {
      if (this.photofilter === false) return true
      for (var key in photo.tags) {
        if (photo.tags[key].id === this.photofilter) return true
      }
      photo.selected = false
      return false
    },
    selectPhoto (photo) {
      photo.selected = true
    },
    toggleZipSelect () {
      if (!this.zipselect) {
        this.zipselect = true
        this.fullsizeview = false
      } else {
        this.zipselect = false
      }
    },
    zipSelectAll (param) {
      this.PLDetails.photos.forEach(function (photo) {
        photo.selected = param
      })
    },
    zipDownload () {
      this.zipDownloading = true
      setTimeout(() => {
        this.zipselect = false
        this.zipDownloading = false
      }, 2000)
    },
    addToPullSheet: function (url) {
      this.$root.itemToAdd.plno = this.PLDetails.plnumber
      this.$root.itemToAdd.url = url
      this.$root.itemToAdd.trigger = true
    },
    updateMetaDescription () {
      var tags = {}
      Object.keys(this.PLDetails.categories).forEach(key => {
        var category = this.PLDetails.categories[key]
        tags[category.name] = []
        Object.keys(category.tags).forEach(tagkey => {
          var tagname = category.tags[tagkey].name
          if (tagname !== 'Reality' && tagname !== 'Commercial' && tagname !== 'Residential') tags[category.name].push(tagname)
        })
      })
      var tagtexttype = ''
      if (tags.hasOwnProperty('Type')) tagtexttype = tags['Type'].join('/')
      var tagtextdesign = ''
      if (tags.hasOwnProperty('Design')) tagtextdesign = tags['Design'].join('/')
      var tagtextneighborhood = ''
      if (tags.hasOwnProperty('Neighborhood')) tagtextneighborhood = tags['Neighborhood'][0]

      document.title = this.PLDetails.reneenumber + ' ' + this.PLDetails.property_city + ' ' + tagtexttype + ' for filming - The Renees'
      document.head.querySelector('meta[name=description]').content = 'A ' + tagtextdesign + ', ' + tagtexttype + ' location in ' + tagtextneighborhood + ' available for film, TV, and photo shoots.'
    },
    renderMasonry () {
      setTimeout(() => {
        packeryEvents.$emit('layout', this.$refs.packery)
      }, 10)
    },
    resetMasonry () {
      if (!this.fullsizeview) {
        setTimeout(() => {
          console.log('Packery ref is: ', this.$refs.packery)
          this.enlargedPhoto = null
          packeryEvents.$emit('layout', this.$refs.packery)
        }, 10)
      }
    },
    photoClick (photoIndex) {
      if (this.enlargedPhoto === photoIndex) {
        this.enlargedPhoto = null
      } else {
        this.enlargedPhoto = photoIndex
      }
    },
    keyListener (event) {
      if (this.enlargedPhoto === null) return
      if (event.which === 39) {
        this.enlargedPhoto++
        if (this.enlargedPhoto > this.filteredPhotos.length) this.enlargedPhoto = 0
        event.preventDefault()
      }
      if (event.which === 37) {
        this.enlargedPhoto--
        if (this.enlargedPhoto < 0) this.enlargedPhoto = this.filteredPhotos.length
        event.preventDefault()
      }
    }

  },
  computed: {
    photoTags () {
      var result = {}
      this.PLDetails.photos.forEach(function (photo) {
        if (photo.tags.length === 0) return
        for (var key in photo.tags) {
          if (!result.hasOwnProperty(photo.tags[key].id)) {
            result[photo.tags[key].id] = photo.tags[key]
          }
        }
      })
      return result
    },
    selectedPhotoCount () {
      var result = 0
      this.PLDetails.photos.forEach(function (photo) {
        if (photo.selected) result++
      })
      return result
    },
    selectedPhotoString () {
      var result = ''
      this.PLDetails.photos.forEach(function (photo) {
        if (photo.selected) result += photo.filename + '|'
      })
      return result
    },
    photosInPullSheet () {
      var result = []
      this.activePullSheet.items.forEach(photo => {
        if (photo.plno !== this.PLDetails.plnumber) return
        result.push(photo.url)
      })
      console.log(result)
      return result
    },
    filteredPhotos () {
      var results = []
      this.PLDetails.photos.forEach(photo => {
        if (this.checkPhoto(photo)) results.push(photo)
      })
      return results
    }
  },
  mounted: function () {
    this.$root.logActivity('Viewing Renee Location ' + this.$route.params.reneeid)
  },
  components: {
    BackToTop
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
.loading {
  height: 100vh;
  padding-top: 49vh;
  box-sizing: border-box;
  text-align: center;
  background: #FFF;
}
  .top-images {
    overflow: hidden;
    height: 25vh;
    @include bp(most) {
      height: 350px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .location-content {
    padding-top: 2px;
    @include bp(most) {
      padding-top: 5px;
    }
  }
  section.location-body {
    font-family: $futura;
    @include bp(most) {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      border-top: 30px solid #aa89b7;
      .location-info {
        flex-basis: 20%;
      }
      .photos.grid {
        flex-basis: 80%;
      }
      .photos.full {
        flex-basis: 80%;
      }

    }
  }
  section.location-info {
    .info-header {
        background: #aa89b7;
        padding: 1.25em 1.25em 1em;
        @include bp(most) {
          padding: .5em 2em 2em;
        }
    }
    .pl-columns {
      padding: 1em;
      @include bp(most) {
        padding: 1em 2em;
      }
      @include bp(mobile) {
        .column {
          display: none;
        }
       .column.city {
          display: block;
        }
        &.mobileshow .column {
          display: block;
        }
        & > span {
          display: block;
        }
      }
      & > span {
        /* display: none; */
          @include bp(most) {
            display: none;
          }
      }
    }
    h1 {
      color: #FFF;
      font-family: $lulo;
       margin: 0px;
       font-size: 22px;
       @include bp(most) {
         font-size: 28px;
       }
    }
    .column {
      box-sizing: border-box;
      position: relative;
      padding: .25em 0;
      @include bp(most) {
        padding: 1em 0;
        &:after {
          content: "";
          height: 1px;
          width: 40%;
          display: block;
          position: absolute;
          bottom: 0px;
          left: 12px;
          background: #DFDFDF;
        }
        &:last-child:after {
          display: none;
        }
      }
      @include bp(mobile) {
        &.Area {
          /* margin-top: 1em; */
        }
        p {
          margin: .75em 0;
        }
      }
    }
    h4 {
      font-size: 14px;
      text-transform: uppercase;
      color: #9D9D9D;
      font-weight: 500;
      margin: .125em 0;
      b {
        color: #666;
        font-weight: 500;
        text-transform: none;
      }
    }
    .printonly {
      display: none;
    }
    p {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.3;
      a {
        color: #000;
        text-decoration: none;
      }
    }
  }

  .notes-wrapper {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }
  .notes-wrapper > div {
   @include bp(most) {
     flex: 1;
   }
  }

  .size-selector {
    display: inline-block;
    color: #f8f8f8;
    font-weight: 300;
    padding: 1em 0;
    @include bp(mobile) {
      position: absolute;
      top: 0.5vh;
      right: 1em;
      width: 56px;
      span {
        display: none;
      }
    }
  }

  .buttons {
    display: block;
    padding-top: .25em;
    @include bp(most) {
      display: block;
    }
    a {
      color: #f8f8f8;
      text-decoration: none;
      font-weight: 300;
      line-height: 2;
      display: block;
      margin-left: 0;
      cursor: pointer;
      i {
        vertical-align: middle;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }


  .photos.grid {
    text-align: justify;
    padding: 5px;
    position: relative;
    @include bp(mobile) {
      padding-bottom: 40px;
    }
    .masonry-sizer {
      width: 50%;
      @include bp(most) {
          width: 33.33%;
      }
      @include bp(medium) {
        width: 25%;
      }
      @include bp(large) {
        width: 25%;
      }
    }
    .photo {
/*         display: inline-block; */
        width: 50%;
        margin-bottom: .25em;
/*         transition: width .05s; */
        padding: 0 .125em;
        box-sizing: border-box;
        &.enlarge {
          width: 100%;
          img {
            cursor: url('data:image/svg+xml;utf8,<svg width="48" height="6" xmlns="http://www.w3.org/2000/svg"><path fill="%23FFF" d="M0 6h48V0H0z" fill-rule="evenodd"/></svg>') 24 3, auto;
          }
        }
        @include bp(most) {
          width: 33.33%;
          margin-bottom: .2em;
          &.enlarge {
            width: 66.66%;
            .photo-inner {
              padding-top: 66.7%;
            }

          }
        }
        @include bp(medium) {
          width: 25%;
          margin-bottom: .25em;
          &.enlarge {
            width: 75%;
            .photo-inner {
              padding-top: 66.9%;
            }
          }
        }
        @include bp(large) {
          width: 25%;
          margin-bottom: .25em;
          &.enlarge {
            width: 75%;
            .photo-inner {
              padding-top: 66.89%;
            }
          }
        }
        .photo-inner {
          overflow: hidden;
          position: relative;
          padding-top: 66.69%;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0px;
          cursor: url('data:image/svg+xml;utf8,<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg"><path fill="%23FFF" d="M21 0v21H0v6h21v21h6V27h21v-6H27V0z" fill-rule="evenodd"/></svg>') 24 24, auto;
        }
        .zipcheckbox {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 2;
          top: 0px;
          left: 0px;
          color: #FFF;
          cursor: pointer;
          @include noselect();
          i {
            display: block;
            font-size: 60px;
            right: 16px;
            bottom: 16px;
            position: absolute;
            opacity: .8;
          }
          &.selected {
            background: rgba(255,255,255,.25);
            i {
              opacity: .98;
            }
          }
          &:hover {
            i {
              opacity: 1;
            }
          }
        }
        .addtopullsheet {
         bottom: 10px;
         left: 10px;
        }
    }
    .justifier {
        display: inline-block;
        width: 49%;
        height: 1px;
        @include bp(most) {
          width: 32.8%;
        }
        @include bp(medium) {
          width: 24.25%;
        }
        @include bp(large) {
          width: 19.25%;
        }
    }
  }
  .photos.full {
    padding: 5px;
    img {
      width: 100%;
    }
    .photo {
      margin-bottom: .5em;
    }
    .photo-inner {
      font-size: 0px;
      position: relative;
      overflow: hidden;
      .bottom-overlay, .addtopullsheet {
        font-size: 14px;
      }
    }
  }

  .photo {
    position: relative;
    .bottom-overlay {
      pointer-events: auto;
      position: absolute;
      bottom: -30px;
      width: 100%;
      left: 0px;
      color: $yellow;
      background: rgba(0,0,0,.75);
      padding-left: .25em;
      box-sizing: border-box;
      transition: bottom .25s;
      z-index: 1;
      i {
        line-height: 1.25;
        vertical-align: middle;
        cursor: pointer;
        &.added {
          cursor: default;
        }
      }
      .pullsheet-tooltip {
        position: absolute;
        left: 2em;
        top: 0px;
        line-height: 2;
        width: 16em;
        overflow: hidden;
        height: 2em;
        cursor: pointer;
        &.added {
          cursor: default;
        }
        span {
          display: block;
          position: absolute;
          left: -16em;
          transition: left .25s;
        }
      }
      &:hover .pullsheet-tooltip span {
        left: 0px;
      }
    }
    &:hover .bottom-overlay {
      bottom: 0px;
    }

    .addtopullsheet {
      position: absolute;
      z-index: 2;
      bottom: 25px;
      left: 25px;
      color: #FFF;
      cursor: pointer;
      display: none;
      /* background: rgba(35,39,40,.8); */
      background: rgba(161,99,165,.5);
      border-radius: 50px;
      line-height: 1;
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      /* color: $yellow; */
      color: #FFF;
      font-family: $montserrat;
      font-weight: 500;
      &:hover {
        color: $yellow;
      }
      &.added {
        cursor: default;
        font-size: .75em;
        letter-spacing: -.05em;
        display: block;
      }
    }
    &:hover .addtopullsheet {
      display: block;
    }
  }

  .toggle-switch {
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    position: relative;
    font-size: 12px;
    font-weight: 300;
    cursor: pointer;
		@include noselect();
    @include bp(most) {
      min-width: 10em;
    }
    .option {
      display: inline-block;
      width: 46%;
      position: relative;
      z-index: 2;
      box-sizing: border-box;
      padding: .25em;
      color: $notblack;
      @include bp(most) {
        width: 48%;
        color: #FFF;
      }
      i {
        font-size: 18px;
        vertical-align: middle;
      }
      &.highlighted {
        color: #FFF;
      }
    }
    .highlight {
      width: 50%;
      background: #7c4682;
      position: absolute;
      border-radius: 4px;
      left: 0px;
      top: 0px;
      z-index: 1;
      height: 2em;
      transition: left .1s;
    }
    &.switched .highlight {
      left: 50%;
    }
  }

.zipselect-footer {
  background: #7c4682;
  color: #FFF;
  height: 12em;
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  z-index: 10;
  text-align: right;
  box-sizing: border-box;
  padding: 1em;
  h2 {
    font-weight: 500;
    font-size: 1em;
    display: inline-block;
/*     border-bottom: 1px solid $notblack; */
    margin: .25em 0;
  }
  .selectall {
    font-size: 1.75em;
    font-weight: 500;
    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  p {
    margin: .75em 0;
  }
  .download {
    form {
      display: inline;
    }
    button, .button {
      background: #e6c6e9;
      cursor: pointer;
      display: inline-block;
      padding: .25em 0;
      border: 1px solid $notblack;
      outline: none;
      font-family: $montserrat;
      color: $notblack;
      font-size: 1.25em;
      padding: .5em .75em;
      margin-left: .5em;
      cursor: pointer;
      border-radius: 4px;
      &:hover {
        background: #47214c;
        color: #FFF;
      }
      i {
        vertical-align: middle;
        margin-top: -2px;
        margin-right: 2px;
      }
    }
  }
}

.admin-info {
  padding: 1em 0;
  .difficultyfield {
    text-transform: capitalize;
    i {
      display: inline-block;
      width: 10px;
      border-radius: 5px;
      height: 10px;
      &.green {
        background-color: #2ecc40;
      }
      &.orange {
        background-color: #ff851b;
      }
      &.red {
        background-color: #ef1607;
      }
      &.yellow {
        background-color: #ffe21f;
      }
    }
  }
  span.renees {
    display: inline-block;
    background: #7d4282;
    border-radius: 3px;
    padding: .25em .75em;
    text-transform: uppercase;
    font-size: .825em;
    font-weight: 500;
    color: #FFF;
    letter-spacing: .1em;
  }
  .filemakerbutton, .editbutton {
    background: $yellow;
    display: inline-block;
    border-radius: 3px;
    padding: .25em .5em;
    color: #FFF;
    text-decoration: none;
    margin-top: 1em;
    font-weight: 600;
    font-size: 1em;
    i {
      vertical-align: middle;
      margin-bottom: 3px;
    }
    &.renees {
      background: #7d4282;
    }
  }
  @include bp(mobile) {
    display: none;
    border-bottom: 1px solid #444444;
    &.mobileshow {
      display: block;
    }
  }
    .admin-inner {
      @include bp(most) {
        max-width: 90%;
        margin: 0px auto;
      }
      @include bp(large) {
        max-width: 80%;
      }
    }
    h2 {
      margin-bottom: 0;
    }
    .column {
      box-sizing: border-box;
      /* padding: 0 1em 1em;
      @include bp(most) {
        display: inline-block;
        vertical-align: top;
        border-left: 1px solid #DFDFDF;
        min-height: 6em;
        width: 33%;

      } */
    }
    .contactswrapper {
      display: flex;
      flex-wrap: wrap;
    }
    .contactbox {
      border: 1px solid #aa89b7;
      background: #f9f6fa;
      padding: 0.75em 1em;
      margin: 0 1em 1em 0;
      display: inline-block;
      vertical-align: top;
      border-radius: 2px;
      max-width: 330px;
      label {
        width: 110px;
        display: inline-block;
      }
      span {
        display: inline-block;
        vertical-align: top;
        max-width: 210px;
      }

    }
    .plfield {
      color: $notblack;
      font-size: 12px;
      line-height: 1.75;
      label {
        display: inline-block;
        width: 125px;
        font-size: 11px;
        font-weight: 500;
        color: $darkgrey;
        letter-spacing: -0.03em;
        @include bp(most) {
          width: 113px;
        }
      }
    }
    .subheader {
      font-weight: 600;
      font-size: 12px;
      color: $blue;
      line-height: 1.75;
      margin-top: 1em;
    }
}

.print-header {
  display: none;
  .left {
    width: 11%;
    display: inline-block;
    text-align: left;
  }
  .right {
    float: right;
    text-align: right;
    width: 64%;
    h3 {
      font-size: .825em;
      margin: 0px;
      margin-top: -.25em;
    }
    h4 {
      font-size: .5em;
      margin: 0px;
    }
    a {
      text-decoration: none;
      color: $notblack;
    }
  }
  .clear {
    clear: both;
    height: 1px;
  }
}

@media print {
  .location-info {
    background: #FFF;
    padding: .25em;
    border-bottom: 0px none;
    .info-header {
      display: none !important;
    }
  }
  .options {
    display: none;
  }
  .admin-info, .control-panel, .photo-filter, .top-images {
    display: none;
  }
  div.photos-masonry {
    height: auto !important;
  }
  .print-header {
   display: block;
   width: 100%;
   padding: .25em 1.25em;
   box-sizing: border-box;
   .title {
    font-size: .75em;
    margin-bottom: .25em;
    font-family: Helvetica, Arial, sans-serif;
    margin-top: 0;
    clear: both;
   }
  }
  .pl-listing {
   padding: .5em 0 0;
  }
  .photos.grid {
   padding: .25em 0;
  }
  .addtopullsheet {
    display: none !important;
  }
  .size-selector {
    display: none !important;
  }

  .photos.grid .photo {
    width: 32.8%;
    position: static !important;
    display: inline-block !important;
    margin-bottom: 1%;
     page-break-before: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
    page-break-after: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
    page-break-inside: avoid; /* or 'auto' */
  }
  .photos.grid .justifier {
    width: 32.8%;
  }
  section.location-info {
    .pl-columns {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      & > span {
        display: none !important;
      }
      h2.printonly {
        display: block;
        margin: 0px;
        font-size: 16px;
      }
      h1 {
        font-size: 1em;
        vertical-align: middle;
        span {
          display: none;
        }
      }
      .column {
        box-sizing: border-box;
        display: inline-block;
        padding: 0 .5em;
        min-height: 4em;
        vertical-align: top;
        border-left: 1px solid #DFDFDF;
        width: 15%;
        background: #FFF;
          &.city {
            display: inline-block !important;
            border-left: 0px none;
            padding-left: 0px;
          }
          &.Feature {
            width: 39%;
          }
          h4 {
            font-size: 8px;
          }
          p {
            font-size: 6px;
            font-family: Helvetica, Arial, sans-serif;
          }
      }
    }

  }
}



  .slideup-enter-active, .slideup-leave-active {
    transition: bottom .5s ease;
  }
  .slideup-leave-to, .slideup-enter {
    bottom: -200px;
  }

  .pl-detail.admin {
    .control-panel .size-selector {
      @include bp(mobile) {
/*         top: 0vh; */
      }
    }
  }

</style>



// WEBPACK FOOTER //
// PLDetail.vue?0bed97e2